import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-disable-mfa",
	templateUrl: "./disable-mfa.component.html",
	styleUrls: ["./disable-mfa.component.scss"]
})
export class DisableMfaComponent {
	public mfa_code: string;
	public errormessage: string;

	constructor(private router: Router, private api: ApiService) { }

	async DisableMFA() {
		if (!this.mfa_code) return;
		await this.api.DisableMFA(this.mfa_code);
		setTimeout(() => {
			this.router.navigate(["/dash/account"]);
		}, 1000);
	}
}
